import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import dayjs from 'dayjs';
import QRCode from 'qrcode.react';
import styles from '../DiscountBtn.module.less';

import config from '../../../layouts/ButtonPay/config';
import { logging } from '../../../actions/log';
import {
  setOrderInfo,
  setAntiInfo,
  setAntiErr,
  setPayPaySuc,
  setPayCheckIdSuc,
} from '../../../actions/buttonpay';
import { getPayGamePayList } from '../../../actions/native';
import { getLocalSoft } from '../../../actions/native';
import { PCStoreJsBridge } from '../../../nativeapi';
import { downloadAddSoft } from '../../../actions/downloadTask';
import { emptyLoginClose } from '../../../actions/user';
import native from '../../../reducers/native';
import Toast from '../../Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);

const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectPayGamePayList = createSelector(
  state => state.native,
  native => native.payGamePayList,
);

const selectButtonPay = createSelector(
  state => state.buttonpay,
  buttonpay => buttonpay,
);

const selectLoginClose = createSelector(
  state => state.user,
  user => user.loginBoxClose,
);

export default memo(
  ({
    soft,
    info = {},
    logInfo = {},
    reductionTag = () => {},
    clickCallbackTag = false,
    hoverTag = false,
  }) => {
    let cn_sbutton_open = styles.sbutton_open;

    const dispatch = useDispatch();
    const userInfo = useSelector(selectUserInfo);
    const logInfoData = useSelector(selectLogInfo);
    const payList = useSelector(selectPayGamePayList); // 正在下载
    const downloadSofts = useSelector(selectDownloadSofts); // 正在下载
    const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
    const installedSofts = useSelector(selectInstalledSoft); // 已经安装
    const silentInstSoft = useSelector(selectSilentInstSoft); // 支持快速静默安装的应用列表
    const isEnabledSilent = useSelector(selectIsEnabledSilent); // 是否打开快速静默安装

    const { btnPayPaySuc, btnPayAntiSuc } = useSelector(selectButtonPay);

    const [isDownloadEnd, setIsDownloadEnd] = useState(false);
    const [loginNeedOrdering, setloginNeedOrdering] = useState(false);
    const [ordering, setOrdering] = useState(1);
    const [fondSoft, setFondSoft] = useState(undefined);
    const [upgrade, setUpgrade] = useState(undefined);
    const [silentSoft, setSilentSoft] = useState(undefined);
    const [installed, setInstalled] = useState(undefined);
    const [buttonText, setButtonText] = useState('下载试用');
    const loginBoxClose = useSelector(selectLoginClose);
    const [buttonBtnStyles, setButtonBtnStyles] = useState(null);

    useEffect(() => {
      if (clickCallbackTag) {
        handleSoft();
        reductionTag();
      }
    }, [clickCallbackTag]);

    // 支付成功之后开始下载
    useEffect(() => {
      if (
        soft &&
        btnPayPaySuc &&
        btnPayPaySuc?.soft &&
        btnPayPaySuc?.soft?.softID === soft?.softID &&
        btnPayPaySuc?.result &&
        btnPayPaySuc?.result?.payStatus === 1 &&
        !isDownloadEnd
      ) {
        handleOrderPaySuccess();
      }
    }, [soft, btnPayPaySuc, isDownloadEnd]);

    // 查询当前是否已经安装
    useEffect(() => {
      if (upgradeSofts) {
        setUpgrade(
          upgradeSofts.find(
            soft_ =>
              soft_.androidType !== '1' &&
              (soft_.softID === soft?.extInfo?.appInfo.softID ||
                soft_.SoftID === soft?.extInfo?.appInfo.softId),
          ),
        );
      }
    }, [soft, upgradeSofts]);

    // 查询当前是否已经安装 并且是否可升级
    useEffect(() => {
      if (installedSofts) {
        setInstalled(
          installedSofts.find(
            soft_ =>
              soft_.softID === soft?.extInfo?.appInfo.softID ||
              soft_.SoftID === soft?.extInfo?.appInfo.softID,
          ),
        );
      }
    }, [soft, installedSofts]);

    // 查询是否打开静默安装的开关
    // 查询当前是否已经安装 并且是否可升级
    useEffect(() => {
      if (silentInstSoft && isEnabledSilent) {
        setSilentSoft(silentInstSoft.find(soft_ => soft_.softID === soft?.extInfo?.appInfo.softID));
      }
    }, [soft, silentInstSoft, isEnabledSilent]);

    // 更新按钮显示状态
    useEffect(() => {
      let button_Text = '下载试用';
      const found =
        downloadSofts &&
        downloadSofts.find(
          soft_ =>
            soft_.type === 'pc' &&
            (soft_.pc.SoftID === soft?.extInfo?.appInfo.softID ||
              soft_.pc.SoftID === soft?.extInfo?.appInfo.SoftID ||
              soft_.pc.SoftID === soft?.extInfo?.appInfo.softId),
        );
      // 正在任务中...
      if (found && found.pc && found.pc.SoftID) {
        setButtonBtnStyles(styles.sbutton_busing);
        if (found.attr.status === 'pre') {
          button_Text = '准备中';
        } else if (found.attr.status === 'wait') {
          button_Text = '等待中';
        } else if (found.attr.status === 'pause') {
          button_Text = '继续下载';
        } else if (found.attr.status === 'dl') {
          button_Text = `下载中${
            found.attr && found.attr.progress ? found.attr.progress.toFixed(0) : 0
          }%`;
        } else if (found.attr.status === 'i') {
          button_Text = (
            <>
              安装中<div className={styles.ellipsis}>...</div>
            </>
          );
          setIsDownloadEnd(true);
        }
      }
      if (!found && installed) {
        button_Text = '立即购买';
      }
      if (!found) {
        setButtonBtnStyles(null);
      }

      if (buttonText !== button_Text) {
        setButtonText(button_Text);
      }

      setFondSoft(found || undefined);
    }, [dispatch, soft, downloadSofts, upgrade, installed, silentSoft, isEnabledSilent]);

    // 获取生成打桩参数
    const getLogParam2 = useCallback(
      (soft_info, logInfo_para) => {
        const logParam2 = {
          source: logInfo_para.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: soft_info?.extInfo?.appInfo.softID,
          softName: soft_info.name,
          softType: '12', // 0: PC应用 1： 安卓  10：外链购买   11：iframe购买  12：单机付费购买
          type: upgrade ? 'u' : 'd', // 更新还是下载
          url: soft_info?.extInfo?.appInfo.downLoadUrl,
        };

        return logParam2;
      },
      [logInfoData, upgrade],
    );

    // 点击按钮处理
    const handleInstallSoft = useCallback(
      (soft_info, button_Text, logInfo_para, fond_soft) => {
        const logParam2 = getLogParam2(soft_info, logInfo_para);
        // 获取静默安装参数
        let installparams = null;
        if (
          isEnabledSilent &&
          silentSoft &&
          silentSoft.softID === soft_info?.extInfo?.appInfo.softID
        ) {
          installparams = {};
          logParam2.type = upgrade ? 'xu' : 'xd';
          if (silentSoft.silentParamDic) {
            installparams.quiet = silentSoft.silentParamDic;
          }
          if (silentSoft.silentDirParamDic) {
            installparams.todir = silentSoft.silentDirParamDic;
          }
        }

        let isNeedLog = false;
        const softInfo = {
          ...soft_info?.extInfo?.appInfo,
          logInfo: logParam2,
          installparams,
          isClick: 'click',
        };
        // 正常安装
        if (button_Text === '下载试用') {
          // 添加下载任务
          dispatch(downloadAddSoft({ ...softInfo, bizInfo: soft_info?.bizInfo }));
          isNeedLog = true;
          dispatch(
            logging({
              category: 'C',
              action: 'Install',
              label: '',
              param2: logParam2,
              param3: soft_info.bizInfo || null,
            }),
          );
        }

        // 正在暂停中，点击继续
        if (fond_soft && fond_soft.attr && fond_soft.attr.status === 'pause') {
          logParam2.isPause = '0';
          PCStoreJsBridge.downloadResume({ ...fond_soft });
          isNeedLog = true;
        }
      },
      [dispatch, installed, silentSoft, isEnabledSilent],
    );

    const handleSoft = useCallback(async () => {
      if (buttonText.indexOf('下载试用') > -1 || buttonText.indexOf('继续下载') > -1) {
        handleInstallSoft(soft, buttonText, logInfo, fondSoft);
        return;
      }
      if (buttonText.indexOf('立即购买') > -1) {
        PCStoreJsBridge.openSoft(installed);
      }
    }, [userInfo, soft, buttonText, logInfo, fondSoft]);

    const showTriangle = text => {
      if (text === '下载试用') {
        return true;
      } else if (text === '立即购买') {
        return true;
      } else {
        return false;
      }
    };

    return (
      <>
        <div
          className={`${info?.className} ${cn_sbutton_open} ${buttonBtnStyles} ${
            fondSoft ? info?.download : ''
          } ${hoverTag ? styles.btn_hover : ''}`}
          onClick={e => {
            handleSoft();
          }}
        >
          {buttonText}
          {showTriangle(buttonText) && <span className={`${styles.triangle} ${info?.tagClass}`} />}
        </div>
      </>
    );
  },
);
